import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import SearchInput from 'components/SearchInput';

const IterationIssuesHeader = ({ searchValue, setSearchValue }) => {
  return (
    <Flex padding='medium' justify='space-between' items='center'>
      <Flex items='center'>
        <Icon name='speed' color='shark' size='large' isThin />
        <Text color='shark' size='large' ml='1rem'>
          Delivery breakdown
        </Text>
      </Flex>

      <Flex items='center'>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          height='2.8rem'
        />
      </Flex>
    </Flex>
  );
};

export default IterationIssuesHeader;
